import { render, staticRenderFns } from "./MiniMap.vue?vue&type=template&id=9baa451a&scoped=true&"
import script from "./MiniMap.vue?vue&type=script&lang=js&"
export * from "./MiniMap.vue?vue&type=script&lang=js&"
import style0 from "./MiniMap.vue?vue&type=style&index=0&id=9baa451a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baa451a",
  null
  
)

export default component.exports